import { object, string } from "yup";

export const AttachmentSchema = object({
  id: string(),
  name: string(),
  blob: object({
    signedUrl: string(),
  }),
});
